import { render, staticRenderFns } from "./FormCfgData.vue?vue&type=template&id=694a067e&scoped=true"
import script from "./FormCfgData.vue?vue&type=script&lang=js"
export * from "./FormCfgData.vue?vue&type=script&lang=js"
import style0 from "./FormCfgData.vue?vue&type=style&index=0&id=694a067e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a067e",
  null
  
)

export default component.exports